import { render, staticRenderFns } from "./UserIdColumn.vue?vue&type=template&id=3841fd2f&"
import script from "./UserIdColumn.vue?vue&type=script&lang=js&"
export * from "./UserIdColumn.vue?vue&type=script&lang=js&"
import style0 from "./UserIdColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3841fd2f')) {
      api.createRecord('3841fd2f', component.options)
    } else {
      api.reload('3841fd2f', component.options)
    }
    module.hot.accept("./UserIdColumn.vue?vue&type=template&id=3841fd2f&", function () {
      api.rerender('3841fd2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/UserIdColumn.vue"
export default component.exports